import {storage} from '@/utils'

const defaultInfo = {
  name: '请你代言',
  title: '按效果付费的自助推广平台',
  subtitle: '打造商家专属的代言人体系',
  tel: '+82 028 8324 8014',
  email: '客服：17760523451（微信同号）'
}

export default {
  state: {
    appInfo: storage.get('AppInfo') || defaultInfo
  },
  mutations: {
    updateAppInfo (state, info) {
      state.appInfo = info
    }
  },
  actions: {
    updateAppInfo ({commit}, info) {
      storage.set('AppInfo', info)
      commit('updateAppInfo', info)
    },
    logout ({commit, dispatch}) {
      dispatch('updateToken', '')
      dispatch('updateMerchantInfo', {})
      dispatch('updateMerchantUser', {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js